
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vous rencontrez un collègue porteur du virus. Il est contagieux, mais n'a pas
encore de symptômes. Ni lui ni vous ne respectez les règles de distance et
d'hygiène. `}<strong parentName="p">{`Vous êtes infecté!`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;